import { Controller } from '@hotwired/stimulus';
import numeral from 'numeral';

export default class extends Controller {
  static targets = ['formattedNumber'];

  connect() {
    this.formatNumbers();
  }

  formatNumbers() {
    this.formattedNumberTargets.forEach((target) => {
      const value = target.textContent;
      const format = target.dataset.numeral;
      const formattedValue = numeral(value).format(format);
      
      target.textContent = formattedValue;

      if (target.dataset.tooltip) {
        target.setAttribute('data-tippy-content', numeral(value).format('$0,0'));
        target.setAttribute('data-tippy-placement', 'top');
      }
    });
  }
} 